import React, { FC, useContext } from 'react';
import Box from '@material-ui/core/Box';
import NavigationBar from './Navigation';
import { makeStyles, Theme } from '@material-ui/core/styles';
import SearchBar from './SearchBar';
import StarfarmLogo from '../pictures/starfarmlogo.png';
import PendingApprovalBox from './PendingApprovalBox';
import ScheduledJobsContainer from './ScheduledJobsContainer';
import EventMessageContext from 'stores/EventMessage';
import DescriptionAlert from './@ui/DescriptionAlert';
import { observer } from 'mobx-react-lite';

const useStyles = makeStyles<Theme>((theme) => ({
  sidebar: {
    width: 248,
    minWidth: 248,
    borderRight: '1px solid #2c4660',
    paddingTop: 20,
    backgroundColor: '#031d35',
  },
  mainDiv: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    maxHeight: '100vh',
    minHeight: '100vh',
    // paddingTop: '2.5%',
    // paddingBottom: '1%',
    backgroundColor: '#02172a',
    color:'white',
  },
  contentDiv: {
    maxHeight: '90%',
    minHeight: '90%',
    overflowY: 'auto',
    direction: 'rtl',
    '&::-webkit-scrollbar': {
      width: '7px',
      height: '5px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
      borderRadius: '100px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#9DB0C1',
      borderRadius: '100px',
    },
  },
  scrollableDiv: {
    maxHeight: '100%',
    minHeight: '100%',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '7px',
      height: '5px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
      borderRadius: '100px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#9DB0C1',
      borderRadius: '100px',
    },
  },
  content: {
    direction: 'ltr',
    // padding: '20px 50px',
  },
  rightSide: {
    padding: '0px 10%',
  },
}));

const Layout: FC = ({ children }) => {
  const classes = useStyles();

  const alertManager = useContext(EventMessageContext);

  return (
    <div className={classes.mainDiv}>
      <Box className={classes.sidebar}>
        <NavigationBar />
      </Box>
      <Box width="100%">
          {/* <Box width="100%" padding="0 10%" mb={4}>
            <SearchBar />
          </Box> */}
        <Box className={classes.contentDiv} width="100%">
          <div className={classes.content}>
            {alertManager.severityType && <DescriptionAlert />}
            {children}
          </div>
        </Box>
      </Box>
      {/* <Box
        className={classes.scrollableDiv}
        borderLeft="2px solid #E1EAF1"
        width="24%"
      > */}
        
    </div>
  );
};

export default observer(Layout);
